import IRequest from "../../IRequest";

export interface ITipoLancamentos {
    reqTiposDocumentos: IRequest<TTiposLancamentos>,
    dataTiposDocumentos: TTiposLancamentos[]
  }

export type TTiposLancamentos = {
  id: number;
  nome: string;
  tipo_movimento: 'D' | 'C';
  conta_contabil: number;
  centro_custo: number;
  nome_conta_contabil: string
}

export const defValueTiposLancamentos= {
    id: 0,
    nome: '',
    tipo_movimento: 'C',
    conta_contabil: 0,
    centro_custo: 0,
    nome_conta_contabil: ''
}